import {Dictionary} from "@reduxjs/toolkit";
import {IOrderProduct} from "../models/OrderModel";
import {formatPrice, getQuantity} from "./index";
import { roundNumber } from "../modules/common/helper";

const getPriceDetail: any = (products: Dictionary<IOrderProduct>, orderDiscount: number,toString = true) => {
  const arrKey = Object.keys(products)
  let totalTax = 0;
  let totalPrice = 0;
  let totalDiscount = 0;
  let originPrice = 0;
  let originPriceWithVat = 0;
  if (arrKey.length) {
    arrKey.forEach((key: string) => {

      const item = products?.[key];
      const quantity = getQuantity(item);
      let salePrice = item?.price ?? 0;
      // let marketPrice = item?.best_supplier?.price_sell ?? salePrice;

      if (item?.price_of_agency) {
        salePrice = item?.price_of_agency?.new_sale_price ?? item?.price_of_agency?.sale_price ?? salePrice;
        // marketPrice = item?.price_of_agency?.new_market_price ?? item?.price_of_agency?.market_price ?? marketPrice;
      }
      // @ts-ignore
      // const perDiscount = getReceiveDiscount({
      //   market_price: marketPrice,
      //   sale_price: salePrice
      // })

      const vat = item?.new_vat ?? item?.vat ?? 0;
      // const discount = (marketPrice / 100) * perDiscount * quantity;
      let unitDiscount = roundNumber(salePrice*orderDiscount/100);
      let unitPrice = salePrice - unitDiscount;
      
      let itemAmount = unitPrice * quantity;
      totalTax += itemAmount*vat/100;

      totalPrice += itemAmount;
      totalDiscount += (unitDiscount * quantity);
      originPrice += quantity*salePrice
      originPriceWithVat += quantity*(salePrice + salePrice*vat/100)
    })
  }
  return {
    price: toString ? formatPrice(totalPrice) : totalPrice,
    tax: toString ? formatPrice(totalTax) : totalTax,
    discount: toString ? formatPrice(totalDiscount) : totalDiscount,
    withOutTax: toString ? formatPrice(totalPrice) : totalPrice,
    taxInc: toString ? formatPrice(totalPrice + totalTax) : totalPrice + totalTax,
    originPrice: toString ? formatPrice(originPrice) : originPrice,
    originPriceWithVat: toString ? formatPrice(originPriceWithVat) : originPriceWithVat
  };
}
export default getPriceDetail;